import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { UiAdminModule } from '@eiq/ui';

import { MediaDialogComponent } from './components/media-dialog/media-dialog.component';
import { MediaPickerDialogComponent } from './components/media-picker/media-picker-dialog.component';
import { UploaderComponent } from './components/uploader/uploader.component';
import { DragAndDropDirective } from './directives/drag-and-drop/drag-and-drop.directive';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatProgressSpinner,
    MatButton,
    MatDialogActions,
    MatIconButton,
    MatTooltip,
    MatDialogTitle,
    MatDialogContent,
    MatCheckbox,
    UiAdminModule
  ],
  declarations: [MediaDialogComponent, MediaPickerDialogComponent, UploaderComponent, DragAndDropDirective],
  exports: [MediaDialogComponent, MediaPickerDialogComponent, UploaderComponent]
})
export class EiqFilesModule {}
